import { render, staticRenderFns } from "./PublicationSocialStar.vue?vue&type=template&id=5906614c&scoped=true&"
import script from "./PublicationSocialStar.vue?vue&type=script&lang=js&"
export * from "./PublicationSocialStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906614c",
  null
  
)

export default component.exports